import { render } from "./crm-journeys.vue?vue&type=template&id=54c7e38e&scoped=true"
import script from "./crm-journeys.vue?vue&type=script&lang=js"
export * from "./crm-journeys.vue?vue&type=script&lang=js"

import "./crm-journeys.vue?vue&type=style&index=0&id=54c7e38e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c7e38e"]])

export default __exports__